






































import bindsAttrs from '@/mixins/binds-attrs';
import Validatable from '@/mixins/validatable';
import { deepEqual } from '@/utils/helpers';
import mixins from '@/utils/mixins';
import { PropType } from 'vue';

const baseMixins = mixins(bindsAttrs, Validatable);

interface Options extends InstanceType<typeof baseMixins> {
  lazyValue: File[] | File;
  multiple: boolean;

  click(): void;
  onClick(): void;

  $refs: {
    input: HTMLInputElement;
    fileInput: Options;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'RenderlessDragAndDrop',

    props: {
      hideDetails: [Boolean, String] as PropType<boolean | 'auto'>,
      multiple: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false }
    },

    data() {
      return {
        isDragging: false,
        internalDragCounter: 0,
        badInput: false
      };
    },

    computed: {
      internalValue: {
        get(): File | File[] {
          return this.lazyValue;
        },
        set(val: File | File[]) {
          this.lazyValue = val;
          this.$emit('input', val);
          this.$emit('change', val);
        }
      },

      isDirty(): boolean {
        return this.lazyValue?.toString().length > 0 || this.badInput;
      }
    },

    watch: {
      value(v) {
        const value = this.multiple ? v : v ? [v] : [];

        if (!deepEqual(value, this.$refs.fileInput.$refs.input.files)) {
          // When the input value is changed programatically, clear the
          // internal input's value so that the `onInput` handler
          // can be triggered again if the user re-selects the exact
          // same file(s). Ideally, `input.files` should be
          // manipulated directly but that property is readonly.
          this.$refs.fileInput.$refs.input.value = '';
        }

        this.lazyValue = v;
      }
    },

    methods: {
      dragEnter() {
        this.internalDragCounter += 1;
        this.isDragging = true;
      },
      // need so when files dragged over does
      dragOver() {},
      dragLeave() {
        this.internalDragCounter -= 1;
        if (this.internalDragCounter === 0) this.isDragging = false;
      },

      drop(event: DragEvent) {
        this.internalDragCounter = 0;
        this.isDragging = false;
        const files = Array.from(event.dataTransfer?.files ?? []);

        if (files.length > 0) {
          // when multiple is set, the file input component expects an array, otherwise just the single file
          this.internalValue = this.multiple ? files : files[0];
        }
      },

      clickDragDrop() {
        if (this.$refs.fileInput) {
          this.$refs.fileInput.$refs.input.click();
        }
      },

      onInput(e: Event) {
        const target = e.target as HTMLInputElement;
        this.badInput = target.validity && target.validity.badInput;
      }
    }
  });
